// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1v74Y","productName":"Table_productName__10ZcH"};